document.addEventListener("DOMContentLoaded", function () {
  // Run free gift logic only on cart pages.
  if (!window.location.pathname.match(/^\/cart/)) return;

  // ----- Configuration -----
  const freeGift1Handle = "free-eye-brush";    // qualifies at $100
  const freeGift2Handle = "free-face-brush";     // qualifies at $150
  const threshold1 = 10000; // $100 threshold (in cents)
  const threshold2 = 15000; // $150 threshold (in cents)

  // ----- Debounce & Process Flags -----
  let isProcessing = false;
  let lastUpdateTime = 0;
  const debounceDelay = 2000; // in milliseconds
  let refreshTriggered = false;

  // ----- Manual Update Flag (if needed) -----
  let manualUpdateInProgress = false;
  const cartForm = document.querySelector("form.cart");
  if (cartForm) {
    cartForm.addEventListener("submit", function () {
      manualUpdateInProgress = true;
      // Clear flag after 3 seconds so free-gift logic runs after manual update finishes.
      setTimeout(() => { manualUpdateInProgress = false; }, 3000);
    });
  }

  // ----- Helper Functions -----

  // Fetch product JSON by handle and return its first variant's ID as a number.
  async function fetchVariantId(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error(`Failed to fetch product: ${handle}`);
      const product = await response.json();
      return Number(product.variants[0].id);
    } catch (error) {
      console.error("Error fetching variant ID for", handle, error);
      return null;
    }
  }

  // Add a free gift using Shopify's AJAX API.
  // Adds a custom property "FreeGift" with the friendly label.
  async function addFreeGift(variantId, giftLabel) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { FreeGift: giftLabel }
        })
      });
      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`Failed to add free gift ${variantId}: ${errorData}`);
      }
      console.log("Free gift added:", variantId, "with label:", giftLabel);
    } catch (error) {
      console.error("Error adding free gift:", error);
    }
  }

  // Remove a free gift by finding its line number (based on the custom property)
  // and calling /cart/change.js with that line number.
  async function removeFreeGift(variantId, cart) {
    let lineNumber = null;
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      // Changed condition: instead of checking for "true" string, we check if the property exists.
      if (Number(item.variant_id) === variantId && item.properties && item.properties.FreeGift) {
        lineNumber = i + 1; // Shopify line numbers are 1-indexed
        break;
      }
    }
    if (!lineNumber) {
      console.log("No free gift found for removal for variant", variantId);
      return;
    }
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: lineNumber, quantity: 0 })
      });
      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`Failed to remove free gift ${variantId}: ${errorData}`);
      }
      console.log("Free gift removed:", variantId);
    } catch (error) {
      console.error("Error removing free gift:", error);
    }
  }

  // ----- Main Update Function -----
  async function updateFreeGifts() {
    if (manualUpdateInProgress) {
      console.log("Manual update in progress; skipping free gift check.");
      return;
    }
    const now = Date.now();
    if (isProcessing || now - lastUpdateTime < debounceDelay) return;
    isProcessing = true;
    lastUpdateTime = now;

    try {
      const res = await fetch("/cart.js");
      if (!res.ok) throw new Error("Failed to fetch cart data");
      const cart = await res.json();
      const total = cart.total_price;
      const cartVariantIds = cart.items.map(item => Number(item.variant_id));

      // Dynamically fetch free gift variant IDs.
      const [freeGift1VariantId, freeGift2VariantId] = await Promise.all([
        fetchVariantId(freeGift1Handle),
        fetchVariantId(freeGift2Handle)
      ]);
      if (!freeGift1VariantId || !freeGift2VariantId) {
        isProcessing = false;
        return;
      }

      const operations = [];

      // Free Gift 1: Add if total >= threshold and not present; remove if total < threshold and present.
      if (total >= threshold1 && !cartVariantIds.includes(freeGift1VariantId)) {
        operations.push(addFreeGift(freeGift1VariantId, "BOM-GIVE"));
      } else if (total < threshold1 && cartVariantIds.includes(freeGift1VariantId)) {
        operations.push(removeFreeGift(freeGift1VariantId, cart));
      }

      // Free Gift 2: Same logic for threshold2.
      if (total >= threshold2 && !cartVariantIds.includes(freeGift2VariantId)) {
        operations.push(addFreeGift(freeGift2VariantId, "BOM-05"));
      } else if (total < threshold2 && cartVariantIds.includes(freeGift2VariantId)) {
        operations.push(removeFreeGift(freeGift2VariantId, cart));
      }

      if (operations.length > 0) {
        await Promise.all(operations);
        // Instead of forcing a full page reload, call Shopify.getCart() if available.
        if (window.Shopify && typeof Shopify.getCart === "function") {
          Shopify.getCart();
        } else if (!refreshTriggered) {
          refreshTriggered = true;
          setTimeout(() => {
            location.reload();
          }, 1500);
        }
      }
    } catch (error) {
      console.error("Error updating free gifts:", error);
    } finally {
      isProcessing = false;
    }
  }

  // ----- Run on Page Load and Listen for Cart Updates -----
  updateFreeGifts();
  document.addEventListener("cart:updated", updateFreeGifts);
});
